<template lang="html">
  <diV id="barChart" class="barChart"></diV>
</template>

<script>
const echarts = require('echarts')
export default {
  name: 'barChart',
  props: {
    data: Object
  },
  data() {
    return {
      chartInstance: null
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function(n, o) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      // 接收数据，渲染表格
      let chart = this.chartInstance
      if (chart) {
        chart.dispose()
      }

      const id = '#barChart'
      const dom = document.querySelector(id)
      this.chartInstance = chart = echarts.init(dom)
      const options = {
        emphasis: {},
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: this.data.grid,
        xAxis: this.data.xAxis,
        yAxis: this.data.yAxis,
        series: this.data.series,
        itemStyle: {
            color: '#41b48c'
        }
      }

      chart.setOption(options)
      setTimeout(() => {
        const captureImg = chart.getDataURL({
          type: 'png',
          backgroundColor: '#f9f9f9'
        })
        if (captureImg) {
          this.$emit('getCapture', captureImg)
        }
      }, 0)
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="less" scoped>
  .barChart {
    height: auto;
    min-height: 400px;
    width: 100%;
  }
</style>
